"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var constants_1 = require("../../../shared/constants");
var validation_1 = require("../../../shared/util/validation");
var constants_2 = require("../constants");
var requests_1 = require("../../app/util/requests");
var FormTag_1 = __importDefault(require("./FormTag"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        fixedHelperText: {
            position: 'absolute',
            top: '100%',
            left: 0,
            width: 'auto',
        },
        menuPopper: {
            zIndex: 1301, // To place popper above create link modal with default z-index of 1300
        },
        menuPaper: {
            display: 'flex',
            flexDirection: 'column',
        },
        menuButton: {
            fontWeight: 500,
            paddingLeft: 30,
            paddingRight: 30,
            borderRadius: 0,
            justifyContent: 'flex-start',
        },
        outlinedTagsTextInput: {
            padding: theme.spacing(0),
            flexWrap: 'wrap',
        },
        tagsTextInput: {
            flexGrow: 1,
            height: '100%',
            minHeight: constants_2.TEXT_FIELD_HEIGHT,
            width: 0,
            minWidth: '50px',
            padding: theme.spacing(0),
            marginLeft: theme.spacing(1),
            lineHeight: 1.5,
        },
        tagsText: {
            width: '100%',
        },
    });
});
function TagsAutocomplete(_a) {
    var tags = _a.tags, setTags = _a.setTags, tagInput = _a.tagInput, setTagInput = _a.setTagInput, disabled = _a.disabled, fixHelperTextPosition = _a.fixHelperTextPosition;
    var classes = useStyles();
    var _b = __read((0, react_1.useState)([]), 2), tagSuggestions = _b[0], setTagSuggestions = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), tagAnchorEl = _c[0], setTagAnchorEl = _c[1];
    function resetTagSuggestions() {
        setTagAnchorEl(null);
        setTagSuggestions([]);
    }
    function addTagInputToTags() {
        if ((0, validation_1.isValidTag)(tagInput) && !tags.includes(tagInput)) {
            setTagInput('');
            setTags(__spreadArray(__spreadArray([], __read(tags), false), [tagInput], false));
        }
    }
    function onClickAway() {
        resetTagSuggestions();
        addTagInputToTags();
    }
    (0, react_1.useEffect)(function () {
        function getTagSuggestions() {
            return __awaiter(this, void 0, void 0, function () {
                var res, newTagSuggestions, filteredTagSuggestions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, requests_1.get)("/api/user/tag?searchText=".concat(tagInput))];
                        case 1:
                            res = _a.sent();
                            if (res.status !== 200)
                                return [2 /*return*/];
                            return [4 /*yield*/, res.json()
                                // Remove existing tags from tag suggestions
                            ];
                        case 2:
                            newTagSuggestions = _a.sent();
                            filteredTagSuggestions = newTagSuggestions.filter(function (tagSuggestion) { return !tags.includes(tagSuggestion); });
                            setTagSuggestions(filteredTagSuggestions);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (tagInput.length < constants_1.MIN_TAG_SEARCH_LENGTH || !(0, validation_1.isValidTag)(tagInput)) {
            resetTagSuggestions();
            return function () { };
        }
        var timeoutId = setTimeout(getTagSuggestions, constants_2.SEARCH_TIMEOUT);
        return function () {
            clearTimeout(timeoutId);
        };
    }, [tagInput]);
    return (react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: onClickAway },
        react_1.default.createElement("div", null,
            react_1.default.createElement(lab_1.Autocomplete, { multiple: true, freeSolo: true, options: [''], value: tags, disabled: disabled, renderTags: function (tags) {
                    return tags.map(function (tag) { return (react_1.default.createElement(FormTag_1.default, { key: tag, tag: tag, onClose: function () {
                            setTags(tags.filter(function (t) { return t !== tag; }));
                            setTagInput('');
                            resetTagSuggestions();
                        } })); });
                }, renderInput: function (params) { return (react_1.default.createElement(core_1.TextField, { disabled: params.disabled, error: !(0, validation_1.isValidTag)(tagInput, true) || tags.includes(tagInput), className: classes.tagsText, onKeyDown: function (event) {
                        if (['Enter', ',', ' '].includes(event.key)) {
                            // Use enter, comma, or space to create a new tag
                            event.preventDefault(); // prevent form from submitting when enter key is pressed
                            event.stopPropagation(); // prevent freeSolo from clearing text input
                            addTagInputToTags();
                        }
                        else if (event.key === 'Backspace' &&
                            tagInput === '' &&
                            tags.length > 0) {
                            // Use backspace to remove existing tag
                            setTags(tags.slice(0, -1));
                        }
                    }, inputProps: params.inputProps, InputProps: {
                        startAdornment: params.InputProps.startAdornment,
                        className: classes.outlinedTagsTextInput,
                        classes: {
                            input: classes.tagsTextInput,
                        },
                    }, variant: "outlined", placeholder: tags.length < constants_1.MAX_NUM_TAGS_PER_LINK ? 'Add tag' : '', onChange: function (event) {
                        setTagInput(event.target.value);
                        setTagAnchorEl(event.target);
                    }, value: tagInput, helperText: (function () {
                        if (!(0, validation_1.isValidTag)(tagInput, true)) {
                            return "Tags should only consist of letters, numbers, hyphens and underscores and be no more than ".concat(validation_1.MAX_TAG_LENGTH, " characters long.");
                        }
                        if (tags.includes(tagInput)) {
                            return 'This tag already exists.';
                        }
                        return '';
                    })(), FormHelperTextProps: fixHelperTextPosition
                        ? { className: classes.fixedHelperText }
                        : {} })); } }),
            react_1.default.createElement(core_1.Popper, { open: tagSuggestions.length > 0 && Boolean(tagAnchorEl), anchorEl: tagAnchorEl, className: classes.menuPopper, placement: "bottom-start" },
                react_1.default.createElement(core_1.Paper, { className: classes.menuPaper }, tagSuggestions.map(function (tagSuggestion) {
                    return (react_1.default.createElement(core_1.Button, { className: classes.menuButton, key: tagSuggestion, onClick: function () {
                            setTags(__spreadArray(__spreadArray([], __read(tags), false), [tagSuggestion], false));
                            setTagInput('');
                            resetTagSuggestions();
                        } }, tagSuggestion));
                }))))));
}
exports.default = TagsAutocomplete;
